import { ChangeDetectionStrategy, Component, computed, Input, signal, Signal, WritableSignal } from '@angular/core';
import { NgClass } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ActionModalTemplate } from '@core';
import { AssignGameItem } from '../../application/models';

@Component({
  selector: 'lib-assign-games-to-team',
  templateUrl: './assign-games-to-team.component.html',
  styleUrls: ['./assign-games-to-team.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [IonicModule, NgClass]
})
export class AssignGamesToTeamComponent implements ActionModalTemplate<string[]> {
  @Input() games: AssignGameItem[] = [];

  private readonly selectedIds: WritableSignal<string[]> = signal<string[]>([]);

  readonly selected: Signal<string[] | null> = computed(() => {
    const ids: string[] = this.selectedIds();

    return ids.length ? ids : null;
  });

  isSelected(gameId: string): boolean {
    return this.selectedIds().includes(gameId);
  }

  toggle(gameId: string): void {
    this.selectedIds.update((ids: string[]) =>
      ids.includes(gameId) ? ids.filter((id: string) => id !== gameId) : [...ids, gameId]
    );
  }
}
